"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POST_STATUSES = void 0;
var POST_STATUSES = exports.POST_STATUSES = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  PRIVATE: 'private',
  SCHEDULED: 'scheduled',
  PENDING: 'pending',
  PITCH: 'pitch'
};
Object.freeze(POST_STATUSES);